const FLASH = ["ring-2", "ring-primary", "ring-offset-2", "ring-offset-background"];

/**
 * Scroll a rendered message into view and flash an outline round it, so it's
 * easy to spot after a jump from search or the pinned list. Returns false when
 * the element isn't rendered (the message isn't loaded yet).
 */
export function flashMessage(elementId: string): boolean {
    const el = document.getElementById(elementId);
    if (!el) return false;
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    el.classList.add(...FLASH);
    window.setTimeout(() => el.classList.remove(...FLASH), 1800);
    return true;
}
